<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 银行支付场景:说明信息卡片
 * @Date: 2021-09-09 09:43:23
 * @LastEditTime: 2021-09-28 10:31:40
-->
<template>
  <div class="bank-form-content">
    <p>Payoneer payment is a manual mode top-up.</p>
    <p>
      To top-up your balance with Payoneer please contact your <b>personal manager</b> for transaction details. <br>
      The minimum payment amount for this payment method is <b style="color: red;">$100</b>.
      
    </p>
    <p>
      Payoneer payment does not support refund.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Payoneer'
}
</script>

<style scoped>
.bank-form-content {
  color: #1e183f;
  max-width: 935px;
  padding: 10px 15px;
  background: #FCFCFF;
  border: 1px solid #E4E7ED;
  border-radius: 3px;
}
</style>
